import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";
import {toast} from "react-toastify";

export const addShift = async (data) => {
        console.log("Shift data",data);
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-create`,
            data,
        );
        console.log("shift api response",response)
        return response;

};

export const updateShift = async (data) => {

        console.log(`Shift update data`, data);
        return await gatewayInstance.put(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-update`,
            data,
        );

};

export const updateShiftUser = async (data) => {
    try {
        console.log(`ShiftUser update data`, data);
        return await gatewayInstance.put(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-user-update`,
            data,
        );
    } catch (e) {
        console.error(e);
    }
};

export const searchShiftData = async (data) => {
    try {
        console.log(`searchShiftData`, data);
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-search`,
            data,
        );
        console.log(`shift serch res`, response);
        return response.data;
        return null;
    } catch (e) {
        console.error(e);
    }
};

export const searchShiftUserData = async (data) => {
    try {
        console.log(`searchShiftData`, data);
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-user-search`,
            data,
        );
        console.log(`user serch res`, response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const searchShiftActionData = async (data) => {
    try {
        console.log(`searchShiftActionData`, data);
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-action-search`,
            data,
        );
        console.log(`action serch res`, response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const getShiftById = async (id) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift/${id}`,
        );
        console.log('shiftById', response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const getShiftUserById = async (id) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-user/${id}`,
        );
        console.log('shiftById', response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
export const getShiftActionById = async (id) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-action/${id}`,
        );
        console.log('actionById', response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
export const shiftUserFindByUserId = async (user) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-user-name/${user}`,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const shiftUserFindByActionId = async (action) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-action_id/${action}`,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
